import { productListPrintModalStyles as styles } from "@hardware/Overrides/Components/ProductListPrintModal";
import { mediaQueriesBP } from "@hardware/Utilities/variables";
import { css } from "styled-components";

styles.productPropertiesCheckboxGridItem = {
    ...styles.productPropertiesCheckboxGridItem,
    css: css`
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        gap: 15px;

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
        }
    `,
};
